var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2C1 1.44772 1.44772 1 2 1H12.5C14.433 1 16 2.567 16 4.5C16 6.433 14.433 8 12.5 8H3.5C2.67157 8 2 8.67157 2 9.5C2 10.3284 2.67157 11 3.5 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H3.5C1.567 13 0 11.433 0 9.5C0 7.567 1.567 6 3.5 6H12.5C13.3284 6 14 5.32843 14 4.5C14 3.67157 13.3284 3 12.5 3H2C1.44772 3 1 2.55228 1 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9375 12.35C16.0694 11.9948 15.9926 11.5797 15.7072 11.2942C15.706 11.293 15.7048 11.2918 15.7037 11.2907L13.5866 9.1729C13.1962 8.78237 12.5632 8.78237 12.1728 9.1729C11.7824 9.56342 11.7824 10.1966 12.1728 10.5871L13.5865 12.0013L12.1728 13.4155C11.7824 13.8061 11.7824 14.4392 12.1728 14.8297C12.5632 15.2203 13.1962 15.2203 13.5866 14.8297L15.7051 12.7105C15.7058 12.7098 15.7065 12.7091 15.7072 12.7084L15.7072 12.7084C15.756 12.6596 15.7987 12.607 15.8353 12.5515"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.b557646588d8ae2c1aad5f9954f90481.svg";
export { ForwardRef as ReactComponent };